import { PaginatorStore, TableColumnSort } from '@warehouse/shared/ui';
import { CHILDREN_LIST_KEY, decodeUrlParam, PersistQueryParamsConfig } from '@warehouse/shared/util';
import { reportError } from '@warehouse/shared/infra';
import { ChildrenTableType } from '../children-table-type';
import { ChildrenColumnName } from '../children-sort';
import { ChildrenTableManagerStore } from './children-table-manager.store';

export const paginatorStoreConfig: PersistQueryParamsConfig<PaginatorStore> = {
	page: {
		type: 'number',
		defaultValue: 1,
	},
	perPage: {
		type: 'number',
		defaultValue: 10,
		localStorageKey: CHILDREN_LIST_KEY,
	},
};

function deserializeSortOn(
	tableType: ChildrenTableType,
	sortableColumns: readonly ChildrenColumnName[],
): (value: string | null) => TableColumnSort<ChildrenColumnName>[] {
	const isSortOnThisTable = (columnSort: unknown): columnSort is TableColumnSort<ChildrenColumnName> => {
		const field = (columnSort as TableColumnSort<string> | null)?.field;
		if (sortableColumns.some((column) => column === field)) return true;
		reportError('children-unknown-sort-column', new Error(`Unknown ${tableType} sort column "${field}"`), {
			field,
			tableType,
		});
		return false;
	};

	return (value) => {
		if (value === null) return [];
		try {
			const savedSort = decodeUrlParam(value);
			if (!Array.isArray(savedSort)) throw new Error('Saved children sort is not a list');
			return savedSort.filter(isSortOnThisTable);
		} catch (error) {
			reportError('children-unreadable-sort', error as Error, { value, tableType });
			return [];
		}
	};
}

export function tableManagerStoreConfig(
	tableType: ChildrenTableType,
	sortableColumns: readonly ChildrenColumnName[],
): PersistQueryParamsConfig<ChildrenTableManagerStore> {
	return {
		visibility: {
			type: 'object',
			defaultValue: {},
			sessionStorageKeyPrefix: `children-list-${tableType}`,
		},
		sort: {
			type: 'object',
			defaultValue: [],
			sessionStorageKeyPrefix: `children-list-${tableType}`,
			customSerializer: { deserialize: deserializeSortOn(tableType, sortableColumns) },
		},
	};
}
